import { Util } from '../utils/Commom';
export var process = function (chart, config) {
    var animate = Util.deepClone(config.animate);
    if (Util.isBoolean(animate)) {
        return chart.animate(animate);
    }
    if (!Util.isEmpty(animate)) {
        return chart.animate(animate);
    }
    return chart;
};
//# sourceMappingURL=setAnimateConfig.js.map